import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import SearchForInvoice from './SearchForInvoice';
import CurrencyFormatter from 'common/currencyFormatter';
import ThemedTableRow from '../../shared/ThemedTableRow';
import { InvoiceSearchProvider } from './InvoiceSearchContext';
import profileService from '../../../services/WebProfileService'
import DeleteInvoiceDialog from '../DeleteInvoiceDialog';
import InfiniteScrollTable from '../../shared/InfiniteScrollTable';
import InvoiceService from '../../../services/WebInvoiceService';
import DateUtility from 'common/DateUtility';
import { InvoiceType } from 'common/constants';

import {
    Checkbox,
    TableHead,
    TableCell,
    TableRow
} from '@material-ui/core';

const ENTER_KEY = 13;

function InvoiceSearchPage(props) {
    
    const [invoices, setInvoices] = useState([]);
    const [invoiceType, setInvoiceType] = useState(InvoiceType.TOW)
    const [unpaidOnly, setUnpaidOnly] = useState(null);
    const [isDateSearch, setIsDateSearch] = useState(true);
    const [isAdmin, setIsAdmin] = useState(null);
    const [isDeleteEnabled, setIsDeleteEnabled] = useState(false);
    const [deleteInvoiceDialogOpen,setDeleteInvoiceDialogOpen] = useState(false);
    const [selected, setSelected] = useState('byDate');
    const [invoiceId, setInvoiceId] = useState('');    
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [skip, setSkip] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    
    useEffect(() => {
        profileService.getProfile( (results) => {
            setIsAdmin(results.admin);
        });
    },[]);

    const invoiceSearchState = {
        setInvoices,
        invoices,
        invoiceType,
        setInvoiceType,
        unpaidOnly,
        setUnpaidOnly,
        isDateSearch,
        setIsDateSearch,
        setDeleteInvoiceDialogOpen,
        deleteInvoiceDialogOpen,
        setInvoiceId,
        selected,
        setSelected,
        setFromDate,
        setToDate,
        fromDate,
        toDate,
    };

    const styles= {
        th : {
            position: 'sticky',
            top: 160,
            backgroundColor:'#FAFAFA',
            zIndex : 100,
        }
    }
    function genTableHeader() {
        return (
            <TableHead>
                <TableRow style={styles.th}>
                    {isAdmin ? <TableCell style={styles.th} padding="checkbox"/> : null}
                    <TableCell style={styles.th} variant="head">Invoice</TableCell>
                    <TableCell style={styles.th} variant="head">Customer</TableCell>
                    <TableCell style={styles.th} variant="head">{InvoiceType.actionDateString(invoiceType)}</TableCell>
                    <TableCell style={styles.th} variant="head">Invoice Total</TableCell>
                    <TableCell style={styles.th} variant="head">Status</TableCell>
                </TableRow>
            </TableHead>
        )
    }

    function isPaid(invoice) {
        return ((invoice.postedToReceivables - invoice.invoiceTotal) >= 0) ? "Paid " : "";
    }

    function invoiceSelector(invoice) {
        return (
          <TableCell padding="checkbox">
            <Checkbox
              id='select'
              indeterminate={false}
              checked={invoice.checked}
              onClick={() => {
                invoice.checked = !invoice.checked;
                setIsDeleteEnabled(checkedInvoices().length > 0);
              }} />
          </TableCell>
        )
    }
    

    function rows()  {
        const { dateToString } = DateUtility;
        const filteredInvoices = unpaidOnly ? invoices.filter((invoice) => !isPaid(invoice)) : invoices;        

        return filteredInvoices ? filteredInvoices.map((invoice, index) => {
            const invoiceNumber = InvoiceType.getNumberForInvoice(invoiceType,invoice);
            return (
                <ThemedTableRow
                    onClick={ (event) => { 
                        if(event.target.id !== 'select') { onRowClicked(invoice) } 
                    } }
                    tabIndex={0}
                    onKeyDown={e => onRowSelected(invoice, e.which)}
                    className='invoice-row'
                    key={`invoice-${invoiceNumber}`}>
                    {isAdmin ? invoiceSelector(invoice) : null}
                    <TableCell id="invoiceNumber">{InvoiceType.getInvoicePrefix(invoiceType)}{invoiceNumber}</TableCell>
                    <TableCell id="customer" >{invoice.name}</TableCell>
                    <TableCell id="dateTowed">{dateToString(invoice.dateTowed || invoice.date)}</TableCell>
                    <TableCell id="invoiceTotal">{CurrencyFormatter.formatUSD(invoice.invoiceTotal)}</TableCell>
                    <TableCell id="paid">{isPaid(invoice)}</TableCell>
                </ThemedTableRow>
            )
        }) : null
    }    

    function getRowsFromServer(take) {
        const postReceiveInvoices = (newInvoices) => {
            setSkip(skip + take);
            setInvoices([...invoices, ...newInvoices]);
            setHasMore(take === newInvoices.length)
        };

        setHasMore(false);
        return new Promise((resolve, reject) => {
            if (invoiceSearchState.selected !== 'byDate') {
                InvoiceService.searchInvoicesByNumber(invoiceId,
                    invoiceSearchState.invoiceType,
                    take,
                    skip,
                    postReceiveInvoices);
            }
            else {
                InvoiceService.searchInvoicesByDate(invoiceSearchState.fromDate,
                    invoiceSearchState.toDate,
                    null,
                    invoiceSearchState.invoiceType,
                    take,
                    skip,
                    postReceiveInvoices);
            }
        });
    }

    useEffect(() => {
        setInvoices([]);
        setSkip(0);
        setHasMore(true);
    }, [fromDate, toDate, selected, invoiceType, invoiceId]);

    function deleteInvoices() {
        const invoiceNumbers = checkedInvoices().map( (invoice) => InvoiceType.getNumberForInvoice(invoiceType,invoice));
        InvoiceService.deleteInvoices(invoiceNumbers, invoiceType, (results) => {
            setInvoices([]);
            setSkip(0);
            setHasMore(true);
            setIsDeleteEnabled(false);
            setDeleteInvoiceDialogOpen(false);
        });
    }

    function checkedInvoices() {
        return invoices ? invoices.filter( (invoice) => { return invoice.checked }) : [];
    }

    function onRowSelected(invoice, which) {
        if (which === ENTER_KEY) {
            onRowClicked(invoice);
        }
    }

    function onRowClicked(invoice) {
        const invoiceId = InvoiceType.getNumberForInvoice(invoiceType, invoice);
        const invoicePart = InvoiceType.editInvoicesPart(invoiceType);
        const customerId = invoice.customerId;
        props.history.push({ pathname: `/customer/${customerId}/${invoicePart}/${invoiceId}` });   
    }

    return (<div>
        <InvoiceSearchProvider value={invoiceSearchState}>
            <SearchForInvoice
                canDelete={isAdmin}
                deleteEnabled={isDeleteEnabled}
                setIsDeleteEnabled={setIsDeleteEnabled} />
            {isAdmin !==null ? <InfiniteScrollTable
                className='invoice-table'
                genTableHeader={genTableHeader}
                rowRender={rows}
                hasMore={hasMore}
                getRowsFromServer={getRowsFromServer}
                /> : <div>Loading...</div>}
            <DeleteInvoiceDialog
                invoicesToDelete={checkedInvoices()}
                onDeleteInvoices ={ ()=> {
                    deleteInvoices();
                }}
                open={deleteInvoiceDialogOpen}
                onClose={() => {
                    setDeleteInvoiceDialogOpen(false);
                }}
            />
        </InvoiceSearchProvider>
    </div>);

}

export default withRouter(InvoiceSearchPage);

